import { useTranslation } from "@refinedev/core";
import dayjs from "dayjs";
import { HTMLAttributes } from "react";

interface TimeSelectionProps extends HTMLAttributes<HTMLDivElement> {
    selectedDate: dayjs.Dayjs;
    selectedTime: Date | null;
    selectedDaySlots: Date[] | undefined;
    onTimeSelect: (time: Date) => void;
    onBookAppointment: () => void;
    isLoadingCreateEvent: boolean;
    isDisabled?: boolean;
}

export const TimeSelection = ({
    selectedDate,
    selectedTime,
    selectedDaySlots,
    onTimeSelect,
    onBookAppointment,
    isLoadingCreateEvent,
    isDisabled,
    className,
    ...rest
}: TimeSelectionProps) => {
    const { translate } = useTranslation()

    return (
        <div className={`flex flex-col overflow-hidden ${isDisabled ? 'opacity-50 pointer-events-none' : ''} ${className ?? ''}`} {...rest}>
            {selectedDate && (
                <div className="mb-4 p-4 bg-base-200 rounded-lg">
                    <h3 className="font-medium capitalize">
                        {dayjs(selectedDate).format("dddd, MMMM D, YYYY")}
                    </h3>
                </div>
            )}

            <div className="flex-1 overflow-y-auto scrollbar-thin">
                {selectedDaySlots && selectedDaySlots.length > 0 ? (
                    <div className="space-y-2">
                        {selectedDaySlots.map((availability, i) => {
                            const isSelected = selectedTime && dayjs(selectedTime).isSame(availability);
                            
                            return (
                                <div key={i} className="flex items-center gap-2">
                                    <button
                                        className={`btn flex-1 justify-start ${
                                            isSelected 
                                                ? 'btn-secondary' 
                                                : 'btn-outline'
                                        }`}
                                        onClick={() => onTimeSelect(availability)}
                                    >
                                        {dayjs(availability).format("HH:mm")}
                                    </button>
                                    
                                    {isSelected && (
                                        <button
                                            className="btn btn-primary gap-2"
                                            onClick={onBookAppointment}
                                            disabled={isLoadingCreateEvent}
                                        >
                                            {isLoadingCreateEvent ? translate("common.loading") : translate("page.appointments.appoint")}
                                        </button>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                ) : (
                    <div className="text-center py-8">
                        <p>{translate("page.appointments.no-slots")}</p>
                    </div>
                )}
            </div>
        </div>
    )
} 